// extracted by mini-css-extract-plugin
export default {"container":"BrandSnippets_container__ML5NN"};